<template>
  <div class="pa-0">
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalUsers"
      :loading="loading"
      class="modern-table no-border"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
    >
      <template v-slot:top>
        <v-sheet color="white" class="px-6 py-4 d-flex align-center border-bottom bg-lightgrey">
          <div class="d-flex align-center">
            <v-avatar size="32" color="primary lighten-5" class="mr-3">
              <v-icon color="primary" x-small>fas fa-users</v-icon>
            </v-avatar>
            <span class="caption font-weight-bold uppercase tracking-widest grey--text">Directorio de Usuarios ({{ totalUsers }})</span>
          </div>
          <v-spacer></v-spacer>
          <div class="d-flex align-center" style="gap: 16px;">
            <v-text-field
              v-model="search"
              placeholder="Buscar por nombre, email, rol..."
              prepend-inner-icon="fas fa-search"
              outlined dense hide-details clearable
              class="modern-search-field"
              style="max-width: 300px;"
              @keyup="searchTimeOut"
              @click:clear="search = ''; fetch()"
            ></v-text-field>
            <v-btn color="primary" @click.stop="CreateUpdate" class="shadow-sm rounded-lg text-none px-4">
              <v-icon left small>fas fa-plus</v-icon>
              Nuevo Usuario
            </v-btn>
          </div>
        </v-sheet>
      </template>

      <!-- Custom Item Slots -->
      <template v-slot:item.first_name="{ item }">
        <div class="d-flex align-center py-2">
          <v-avatar size="32" color="primary lighten-5" class="mr-3">
            <span class="primary--text font-weight-black" style="font-size: 12px;">{{ item.first_name[0] }}{{ item.last_name[0] }}</span>
          </v-avatar>
          <div class="d-flex flex-column">
            <span class="body-2 font-weight-black primary--text lh-1-2">{{ item.first_name }} {{ item.last_name }}</span>
            <span class="caption grey--text font-weight-medium">{{ item.email }}</span>
          </div>
        </div>
      </template>

      <template v-slot:item.user_role.name="{ item }">
        <v-chip x-small label outlined class="font-weight-black secondary--text border-secondary-sm">
          {{ item.user_role ? item.user_role.name : 'Sin Rol' }}
        </v-chip>
      </template>

      <template v-slot:item.is_seller="{ item }">
        <v-chip v-if="item.is_seller" x-small label color="blue lighten-5" class="blue--text font-weight-black">
          VENDEDOR
        </v-chip>
        <span v-else class="caption grey--text opacity-40">-</span>
      </template>

      <template v-slot:item.is_active="{ item }">
        <div class="d-flex align-center">
          <v-switch 
            v-model="item.is_active" 
            @change="changeUserStatus(item)" 
            :disabled="!$can('update','User')"
            inset
            dense
            hide-details
            class="scale-switch mt-0"
            color="success"
          ></v-switch>
          <span class="caption font-weight-black ml-2" :class="item.is_active ? 'success--text' : 'grey--text'">
            {{ item.is_active ? 'ACTIVO' : 'INACTIVO' }}
          </span>
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-center">
          <v-btn icon small color="primary" class="grey lighten-4 mr-2" @click.stop="CreateUpdate(item)">
            <v-icon x-small>fas fa-edit</v-icon>
          </v-btn>
          <v-btn icon small color="error" class="grey lighten-4">
            <v-icon x-small>fas fa-trash-alt</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {listUsers,updateUser} from '@/api/auth'
import notifications from '../../utils/notifications'

export default {
  name: 'UsersList',
  data() {
    return {
      items: [],
      totalUsers: 0,
      options: {},
      timer: null,
      headers: [
        { text: 'Colaborador', align: 'start', value: 'first_name', class: "table-header" },
        { text: 'Email', value: 'email', class: "table-header", align: ' d-none' }, // Merged with first_name
        { text: 'Perfil de Acceso', value: 'user_role.name', class: "table-header", width: '180px' ,sortable: false },
        { text: 'Comercial', value: 'is_seller', class: "table-header", align: 'center', width: '120px' ,sortable: false },
        { text: 'Estado Cuenta', value: 'is_active', class: "table-header", width: '160px' ,sortable: false },
        { text: 'Gestión', value: 'actions', class: "table-header", align: 'center', width: '120px', sortable: false }
      ],
      search: '',
      loading: false
    }
  },
  watch: {
    options: {
      handler: 'fetch',
      deep: true,
    },
  },
  methods: {
    searchTimeOut() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => { this.fetch() }, 800)
    },
    async fetch() {
      this.loading = true
      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        const ordering = sortBy && sortBy[0]
          ? (sortDesc[0] ? sortBy[0] : `-${sortBy[0]}`)
          : ''
        const data = await listUsers(page || 1, itemsPerPage || 15, this.search || '', ordering)
        this.totalUsers = data.count
        this.items = data.results
      } catch (e) {
        notifications.showError('Error al cargar usuarios: ' + e)
      } finally {
        this.loading = false
      }
    },
    CreateUpdate(item) {
      const id = item ? item.id : -1
      this.$router.push({ name: 'UsersCreateUpdate', params: { id } })
    },
    async changeUserStatus(item) {
      try {
        await updateUser(item)
        notifications.showSuccess('Usuario actualizado correctamente')
      } catch (error) {
        notifications.showError(error)
      }
    }
  }
}
</script>

<style scoped>
.modern-table { background: transparent !important; }
.modern-table.no-border { border: none !important; }

.modern-table >>> thead th {
  background-color: #f8fbfc !important;
  height: 48px !important;
  text-transform: uppercase;
  font-size: 0.7rem !important;
  letter-spacing: 1px;
  font-weight: 900 !important;
  color: #607d8b !important;
}

.modern-table >>> td {
  height: 64px !important;
  border-bottom: 1px solid #f0f3f5 !important;
}

.bg-lightgrey { background-color: #f8fbfc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.lh-1-2 { line-height: 1.2 !important; }
.uppercase { text-transform: uppercase; letter-spacing: 1px; }
.tracking-widest { letter-spacing: 2px; }
.shadow-sm { box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important; }

.modern-search-field >>> .v-input__control >>> .v-input__slot {
  background-color: white !important;
  border-radius: 10px !important;
}

.scale-switch { transform: scale(0.8); }
.border-secondary-sm { border: 1px solid var(--v-secondary-base) !important; }
.opacity-40 { opacity: 0.4; }
</style>